import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { TagData } from "../models";

@Injectable()
export class TagsService{
    url: string;

  constructor(
    private httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string
  ) {
    this.url = apiUrl + 'Tags/';
  }



  getData(): Observable<TagData[]> {
    const response: Observable<TagData[]> = this.httpClient.get<TagData[]>(`${this.url}current-tag-data`);
    return response;
  }
}